import { KeyTextField } from '@prismicio/client';

import styles from './copyright.module.scss';

const Copyright = ({ companyName }: { companyName: KeyTextField }) => {
  const year = new Date().getFullYear();

  return (
    <div className={styles.copyright}>
      &#169; {year} {companyName} <br />
      All rights reserved.
    </div>
  );
};

export default Copyright;
